module.exports = __webpack_public_path__ + "img/pokephone.80f99f3c.png";